import { usePollingCount, notifyCountUpdated } from './usePollingCount.js'
import { endpoints } from '../services/api.js'

const EVENT_NAME = 'veille-updated'

/**
 * Compte des fiches de veille en attente de validation + à envoyer, exposé pour
 * le badge de notification dans la sidebar. Auto-refresh toutes les 60 secondes +
 * écoute l'event 'veille-updated' pour rafraîchir immédiatement après une action.
 */
export function usePendingVeilleCount() {
  const { toRefs, reload } = usePollingCount({
    endpoint: endpoints.veille.summary(),
    eventName: EVENT_NAME,
    initialState: { pendingVeilleCount: 0, toSendVeilleCount: 0 },
    mapResponse: (data) => {
      let pending = 0
      let toSend = 0
      for (const t of Object.values(data.types || {})) {
        pending += t.pending || 0
        toSend += t.toSend || 0
      }
      return { pendingVeilleCount: pending, toSendVeilleCount: toSend }
    },
  })
  const { pendingVeilleCount, toSendVeilleCount } = toRefs()
  return { pendingVeilleCount, toSendVeilleCount, reloadVeilleCount: reload }
}

export function notifyVeilleUpdated() {
  notifyCountUpdated(EVENT_NAME)
}
